const getVersion = (enablePaywall?: boolean, enablePaywallButtons?: boolean) => {
  let version = enablePaywall ? 'v2' : '';
  if (enablePaywallButtons) {
    version = 'v2.1';
  }
  return version;
};
export default getVersion;
